class C_ViewType
{
    constructor()
    {
        this.NORMAL = 1;
        this.TOP = 2
    }
}

export default (new C_ViewType);